<template>
  <v-app id="inspire" class="bg-dark">
    <v-container class="fill-height" style="padding:0; max-width:100%;" fluid>
      <div class="titleFrame"><img :src="logo.url" :alt="logo.alt" :width="logo.size" class="float-left"></div>
      <div class="imageFrame">
        <img src=""/>
      </div>
      <div class="loginFrame">
        <v-card class="elevation-6 loginField rounded-xl">
       <div class="loginHeader">
         <h2>
          {{ $t('passwordPickTitle') }}
         </h2>
       </div>
        <v-card-text>
          <v-form v-model="isFormValid">

            <v-text-field
              id="password"
              required
              :rules="[rules.required]"
              v-model="password"
              @keyup.enter="login"
              label="Neues Passwort"
              name="password"
              prepend-icon="mdi-lock"
              :append-icon="showPassword ? 'visibility' : 'visibility_off' "
              @click:append="() => (showPassword = !showPassword)"
              :type="showPassword ? 'text' : 'password'"
            ></v-text-field>
            <v-text-field
              id="password"
              required
              :rules="[rules.required, rules.passwordMatch]"
              v-model="passwordValidation"
              @keyup.enter="login"
              label="Passwort erneut eingeben"
              name="password"
              prepend-icon="mdi-lock"
              :append-icon="showValidationPassword ? 'visibility' : 'visibility_off' "
              @click:append="() => (showValidationPassword = !showValidationPassword)"
              :type="showValidationPassword ? 'text' : 'password'"
            ></v-text-field>
            <div v-if="error != null" class="container">
              <v-alert
                type="error"
                style="width: 82%; font-size: 0.8rem;"
              >{{ error }}</v-alert>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions style="justify-content: center; padding: 20px 0;">
          <v-btn color="secondary" elevation="0" @click="submitPassword" style="width:80%"
                 :disabled="!isFormValid">{{ $t('save')
            }}</v-btn>
        </v-card-actions>
      </v-card>
      </div>
      
    </v-container>
  </v-app>
</template>

<script>
import colors from 'vuetify/lib/util/colors'
import loginService from '@/components/loginService.js';
export default {
  name: "login",

  data() {
    return {
      password: "",
      error: null,
      showPassword: false,
      passwordValidation: "",
      showValidationPassword: false,
      isFormValid: false,
      logo: {
        url: require('../../assets/motiverse_logo-hor.png'),
        alt: 'logotype',
        size: '16%'
      },
      rules: {
        required: value => !!value || 'Required.',
        passwordMatch: () => (this.password === this.passwordValidation) || 'Password must match',
      },
    };
  },
  computed: {
    authToken() {
      return this.$route.params.authToken;
    },
  },
  mounted(){
    this.$vuetify.theme.themes.light.primary = '#FC9861';
    this.$vuetify.theme.themes.light.secondary = '#31307A';
  },
  methods: {
    submitPassword() {
      this.errors = [];
      if(this.password != this.passwordValidation){
        this.errors.push("Die Passwörter müssen übereinstimmen");
        return;
      }
      loginService.setPasswordForAuthToken(this.password, this.authToken).then((res) => {
        if(res.data == false){
          this.errors = "Ein Fehler ist aufgetreten";
        }else{
          this.$router.push('/');
        }
      }).catch(e => this.error = e.response.data.msg)
    }
  }
};
</script>
<style scoped>
.bg-dark{
  background-color: #F9F5F2 !important;
  //background-color: #F5F5F5 !important;
}
.loginFrame{
  position: absolute;
  height: 100%;
  left:66%;
  width:36%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.loginFrame a {
  font-weight: 600;
}
.imageFrame{
  position: absolute;
  height: 100%;
  width:66%;
  background: url('~@/assets/login_background.jpg') center no-repeat;
  background-size: cover;
  /*box-shadow: inset 2000px 0 0 0 rgba(0, 156, 145, 0.5);*/
}
.imageFrame::before{
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width:100%;
  background-color: rgb(255 255 255 / 83%);
  opacity: 0.4;
}
.loginField{
  overflow: auto;
  height: fit-content;
  width: fit-content;
  min-width: 75%;
  max-width: 80%;
  padding-bottom: 2vh;
}
.titleFrame{
  position: absolute;
  left: 2.5%;
  top: 2.5%;
  font-style: normal;
  font-weight: 100;
  font-size: 2rem;
  line-height: 64px;

  color: #FFFFFF;
  z-index: 1;
}

.loginHeader{
  text-align-last: center;
  padding: 10%;
  font-family: 'Inter', sans-serif;
  font-style: normal;
  /*font-weight: 500;*/
  font-size: 24px;
  line-height: 28px;

  color: #31307A;
}
@media (max-width: 768px) {
  .imageFrame{
    display: none
  }
  .loginFrame{
    left: 0;
    width:100%;
  }
}
:deep .v-form {
  display: flex;
  justify-content: center;
}
:deep .v-alert .v-icon {
  color: #fff;
}
</style>